import dateTime from "~/kernel/dateTime/dateTime";

/**
 * @deprecated Use `dateTime(dateLeft).difference(dateRight, "minutes")`.
 **/
export default function differenceInMinutes(dateLeft: Date, dateRight: Date) {
  return dateTime(dateLeft).difference(dateRight, "minutes");
}
